"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createNote: function() {
        return createNote;
    },
    default: function() {
        return NotesManager;
    }
});
const _uuid = require("uuid");
const _ = require("..");
function createNote(payload = {}) {
    const { name = "", email = "", text = "" } = payload;
    if (!text) return {};
    const nextNote = {
        id: (0, _uuid.v4)(),
        author: name,
        userEmail: email,
        text,
        date: Date.now(),
        timezone: (0, _.getClientTimeZone)()
    };
    return nextNote;
}
class NotesManager {
    create(payload = {}) {
        const note = createNote(payload);
        this.notes.push(note);
        return note;
    }
    set(notes = []) {
        this.notes = notes;
    }
    deleteById(id) {
        const index = this.notes.findIndex((note)=>note.id === id);
        if (index !== -1) {
            this.notes.splice(index, 1);
        }
    }
    getById(id) {
        return this.notes.find((note)=>note.id === id);
    }
    get() {
        return JSON.parse(JSON.stringify(this.notes));
    }
    /**
   * Creates an instance of NotesManager.
   *
   * @param {Array} initialNotes Initial list of notes. Defaults to an empty array.
   * @memberof NotesManager
   */ constructor(initialNotes = []){
        this.notes = initialNotes;
    }
}
